import { useEffect, useState } from 'react'

export default function useLocationHash(): string | null {
  const [hash, setHash] = useState<string | null>(null)
  useEffect(() => {
    setHash(globalThis.location.hash.slice(1))
  }, [])
  return hash
}
